var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPhone)?_c('van-button',{staticStyle:{"margin-left":"3%","width":"15%"},attrs:{"type":"info","size":"small"},on:{"click":_vm.landscape}},[_vm._v(_vm._s(_vm.screen))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }